// extracted by mini-css-extract-plugin
export var actionButton = "_ho-0";
export var fileInput = "_ho-2";
export var paperclip = "_ho-1";